<div class="wrapper flex vcenter">
  <div class="flex grow1">
    @if (subtitle) {
      <div class="subtitle">{{ subtitle }}</div>
    }
    @if (heading) {
      <div class="title">{{ heading }}</div>
    }
  </div>
  <div class="flex vcenter actions">
    @if (showCreditDisplay) {
      <app-credit-display></app-credit-display>
    }

    <payee-language-selector></payee-language-selector>

    <button
      payee-icon-button
      class="header-action-button"
      color="white"
      routerLink="/user/user-profile"
      [isBorderButton]="true"
      [attr.aria-label]="'HEADER.PROFILE' | translate"
    >
      <img
        alt=""
        src="assets/shared/global-images/icons/user.svg"
      />
    </button>

    <button
      payee-icon-button
      class="header-action-button"
      color="white"
      [isBorderButton]="true"
      [attr.aria-label]="'HEADER.LOGOUT' | translate"
      (click)="logout()"
    >
      <payee-icon name="logout-red"></payee-icon>
    </button>
  </div>
</div>
